import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import apiCall from "../../../helpers/apifactory";
import TrackInfoComponent from "../../common/TrackInfoComponent";
import { ServicesProvider } from "../../common/AlertService";
import { useNavigate } from "react-router-dom";

const Track = () => {
  const navigate = useNavigate();
  const trackNumber = useParams()["*"];

  const [trackData, setTrackData] = useState();
  const [inputTrack, setInputTrack] = useState("");
  const [errorModal, setErrorModal] = useState(false);

  const { loaderShow } = useContext(ServicesProvider);

  const showErrorPopup = () => {
    setErrorModal(true);
  };

  // Scroll to current track on mount only
  useEffect(() => {
    const current_page = window.location.href.split("/").at(-1);
    const timer = setTimeout(() => {
      document
        .getElementById(current_page)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const top = window.scrollY;
      const windowWidth = window.innerWidth;
      const header = document.querySelector("header");
      const nav = document.querySelector("nav");
      const headerHeight = header
        ? parseInt(header.style.height || 0) + 100
        : 100;

      if (nav) {
        top > headerHeight && windowWidth > 1024
          ? nav.classList.add("fixed-header-desktop")
          : nav.classList.remove("fixed-header-desktop");
      }
    };

    window.addEventListener("scroll", handleScroll, false);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (trackNumber) {
      calltrackApi(trackNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackNumber]);

  const calltrackApi = async (tracknum) => {
    if (!tracknum) return;

    loaderShow(true, "Fetching your shipment details");

    try {
      const d = await apiCall.trackApiNew(tracknum);

      if (d?.data?.responseData?.message === "SUCCESS") {
        setTrackData(d?.data?.responseData);
      } else {
        setTrackData(null);
      }
    } catch (error) {
      console.error("Track API Error:", error);
      setTrackData(null);
      showErrorPopup();
    } finally {
      loaderShow(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!inputTrack) return;
      navigate(`/track/${inputTrack}`);
    }
  };

  const onSubmit = () => {
    if (!inputTrack) return;
    navigate(`/track/${inputTrack}`);
  };

  const [tickerKey, setTickerKey] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTickerKey((prev) => prev + 1);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {/* Error Modal */}
      {errorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[9999]">
          <div
            className="bg-white rounded-2xl shadow-2xl flex flex-col items-center text-center relative"
            style={{
              padding: "3rem 4rem",
              minWidth: "380px",
              maxWidth: "440px",
              gap: "0.75rem",
            }}
          >
            {/* Close Icon */}
            <button
              onClick={() => setErrorModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <h2 className="text-[#D40511] font-extrabold text-4xl tracking-wide leading-tight">
              PSST...
            </h2>

            <p className="text-gray-700 text-base leading-relaxed mt-1">
              Something didn't load properly.
              <br />
              Your parcel is still on its way!
            </p>

            <button
              onClick={() => {
                setErrorModal(false);
                if (trackNumber) calltrackApi(trackNumber);
              }}
              className="text-[#D40511] font-bold text-base mt-2 hover:underline"
            >
              Try again in a moment!
            </button>
          </div>
        </div>
      )}

      {/* Ticker Banner */}
      <div className="ticker-wrapper overflow-hidden" key={tickerKey}>
        <div className="ticker">
          <div className="ticker__item">
            <p className="font-bold text-[12px]  ">
              {/* Dear Cricket Fans, The e-ticketing system has now been restored.
              Please revisit your download link to access and print your ticket.
              In case you are unable to print it, your Email Confirmation will
              also be accepted at the stadium gates. We look forward to seeing
              you at the stadium! */}
              <span className="font-bold text-[12px] ml-[3%]">
                Beware of fake calls or messages asking you to click on links,
                share payments, OTPs, or personal details. TCS never asks for
                such details. Our riders only call to confirm name & address
              </span>
            </p>
          </div>
        </div>
      </div>

      <img src="/image.jpg" alt="TCS Banner" className="w-full" />

      {/* Search Form */}
      <div className="my-8 mb-16">
        <div className="text-center">
          <h2 className="text-3xl font-semibold">Track Your Shipment</h2>
          <p className="lg:text-center">
            Enter any combination of TCS tracking Reference number.
          </p>
        </div>
        <div className="flex justify-center mt-2">
          <div className="flex justify-center items-center">
            <input
              onChange={(e) => setInputTrack(e.target.value)}
              onKeyDown={handleKeyDown}
              value={inputTrack}
              type="number"
              placeholder="Tracking Number"
              className="p-3 md:w-[27rem] sm:w-[20rem] w-[10rem] focus:outline-none opacity-75 rounded-l-sm border"
            />
            <button
              onClick={onSubmit}
              type="button"
              className="bg-[#D40511] text-white p-[13px] sm:w-[10rem] w-[9rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>

      {/* Track Result */}
      {trackData ? (
        <TrackInfoComponent value={trackData} />
      ) : trackData === null ? (
        <div className="flex justify-center items-center mb-[8rem]">
          <div className="w-[70rem] shadow-card sm:p-8 p-3">
            <div className="flex gap-4">
              <h2>No Record Found</h2>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Track;
